// extracted by css-extract-rspack-plugin
export default {"SettingRequiredLabel":"RequiredParamToggle-module__SettingRequiredLabel___fDMLa"};